
import TwigMessages from '@marketplace/components/TwigMessages.vue'
import { COOKIE_VISITOR_ID } from '@marketplace/config/cookie.js'
import { getUnlocalizedPathFromRoute } from '@marketplace/helpers/router.js'
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'

export default {
    components: {
        TwigMessages,
    },

    layout: 'empty',

    middleware: ['pageviewMiddleware'],

    props: {
        error: {
            type: Object,
            required: true,
        },
    },

    head() {
        return {
            meta: [
                {
                    hid: 'prerender-status-code',
                    name: 'prerender-status-code',
                    content: this.error.statusCode,
                },
            ],
            bodyAttrs: {
                class: 'bg-creme',
            },
        }
    },

    computed: {
        ...mapGetters('global', ['userCountry']),

        translations() {
            const map = {
                500: {
                    title: this.$t('headings.500.title'),
                    subtitle: this.$t('headings.500.subtitle'),
                },
                404: {
                    title: this.$t('headings.404.title'),
                    subtitle: this.$t('headings.404.subtitle'),
                },
                default: {
                    title: this.$t('headings.error.title'),
                    subtitle: this.$t('headings.error.subtitle'),
                },
            }

            return map[this.error.statusCode] || map.default
        },
    },

    mounted() {
        this.trackPageView()
    },

    methods: {
        trackPageView() {
            window.analytics.ready(() => {
                window.analytics.track('404 Page triggered', {
                    realUserId: window.Store?.userId || '',
                    accountId: window.Store?.accountId || '',
                    visitorCookieId:
                        Cookies.get(COOKIE_VISITOR_ID) || 'systemUser',
                    url: this.$config.appUrl,
                    path: getUnlocalizedPathFromRoute(this.$route),
                    country_code: this.userCountry || '',
                    state: window.Store?.accountType
                        ? 'logged-in'
                        : 'logged-out',
                })
            })
        },
    },
}
